// Seven1991 product gallery: thumbnails, prev/next arrows and a full-screen lightbox.
if (!customElements.get('s19-gallery')) {
  customElements.define(
    's19-gallery',
    class S19Gallery extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.s19-pdp__photo img[data-label]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.dialog = this.querySelector('dialog');
        this.index = 0;
        if (!this.slides.length) return;

        this.addEventListener('click', (event) => {
          const target = event.target.closest('button');
          if (!target) {
            if (event.target === this.dialog) this.dialog.close();
            return;
          }
          if (target.hasAttribute('data-prev')) this.show(this.index - 1);
          else if (target.hasAttribute('data-next')) this.show(this.index + 1);
          else if (target.hasAttribute('data-thumb')) this.show(Number(target.dataset.thumb));
          else if (target.hasAttribute('data-open')) this.openLightbox();
          else if (target.hasAttribute('data-close')) this.dialog.close();
        });

        if (this.dialog) {
          this.dialog.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.show(this.index - 1);
            if (event.key === 'ArrowRight') this.show(this.index + 1);
          });
        }
      }

      show(next) {
        const count = this.slides.length;
        this.index = (next + count) % count;
        this.slides.forEach((img, i) => {
          const on = i === this.index;
          img.hidden = !on;
          img.classList.toggle('is-active', on);
          if (on) img.removeAttribute('loading');
        });
        this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', i === this.index ? 'true' : 'false'));
        const label = this.slides[this.index].dataset.label;
        const counter = `${this.index + 1} / ${count}`;
        const labelEl = this.querySelector('[data-label]:not(img)');
        const countEl = this.querySelector('[data-count]');
        if (labelEl) labelEl.textContent = label;
        if (countEl) countEl.textContent = counter;
        if (this.dialog && this.dialog.open) this.renderLightbox(label, counter);
      }

      renderLightbox(label, counter) {
        const photo = this.dialog.querySelector('[data-lb-photo]');
        const copy = this.slides[this.index].cloneNode();
        copy.hidden = false;
        copy.removeAttribute('loading');
        copy.sizes = '(min-width: 700px) 560px, 86vw';
        photo.replaceChildren(copy);
        const labelEl = this.dialog.querySelector('[data-lb-label]');
        if (labelEl) labelEl.textContent = `${label} · ${counter}`;
      }

      openLightbox() {
        if (!this.dialog) return;
        this.dialog.showModal();
        this.renderLightbox(this.slides[this.index].dataset.label, `${this.index + 1} / ${this.slides.length}`);
      }
    }
  );
}
